import { Component, OnInit, Input, OnChanges, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TransferInformationComponent } from '../../../shared/components/TransferInformation/TransferInformation.component';
import { IFunctionAbility } from '@models/users';
import { CSSThemeService } from '@services/css-theme.service';
import { Angle } from '@models/ncx/angle';

@Component({
    selector: 'app-link-to-angle-or-story',
    templateUrl: './link-to-angle-or-story.component.html',
    styleUrls: ['./link-to-angle-or-story.component.scss'],
    standalone: false
})
export class LinkToAngleOrStoryComponent implements OnInit, OnChanges, AfterViewChecked {

  value = '';

  angleValue = '';

  angleOptions: string[] = [];

  @Input() postRelatedAngles = [];

  @Output() addedAngles = new EventEmitter();

  getAngleStoryTitlesAPI;

  listofAngles: Angle[] = [];

  relatedAngleTitles = [];

  filteredAngleOptions: string[] = [];

  filteredAngleOptionsInit: any[];

  options: string[] = [];

  @Input() postRelatedStories = [];

  @Input() isPinnedOnTop;

  @Output() addedStories = new EventEmitter();

  getStoryTitlesAPI;

  listofStories = [];

  relatedStoryTitles = [];

  filteredOptions: string[] = [];

  filteredOptionsInit: any[];

  isLightMode = false;

  subject: Subject<string> = new Subject();

  angleSubject: Subject<string> = new Subject();

  public functionAbility = {} as IFunctionAbility;

  constructor(
    private cService: CommonService,
    private tI: TransferInformationComponent,
    private themeService: CSSThemeService
  ) {

    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchTextValue => {

      this.getStoryTitlesList(searchTextValue);

    });

    this.angleSubject.pipe(
      debounceTime(700)
    ).subscribe(searchAngle => {

      this.getAngleTitles(searchAngle);

    });

  }

  ngOnInit() {

    this.getStoryTitlesAPI = environment.globalSearch;
    this.functionAbility = { ...this.tI.userFunctionAbility } as IFunctionAbility;

    // this.getStoryTitlesList();

  }

  ngAfterViewChecked() {

    this.isLightMode = this.themeService.currentTheme !== 'dark';

  }

  ngOnChanges() {

    // this.relatedStoryTitles = [];
    if (this.postRelatedStories && this.postRelatedStories.length) {

      this.relatedStoryTitles = JSON.parse(JSON.stringify(this.postRelatedStories));
      this.relatedStoryTitles = this.relatedStoryTitles.map((story) => {

        return {
          storyId: story.storyId,
          storyTitle: (story && story.storyTitle) ? story.storyTitle : '',
          isPrimary: story.isPrimary,
          isPinnedOnTop: this.isPinnedOnTop
        };

      });

      // this.bindTitleDetails();
      // if (!(this.listofStories && this.listofStories.length)) {
      //   this.getStoryTitlesList();
      // } else {
      //   this.bindTitleDetails();
      // }

    }

    if (this.postRelatedAngles && this.postRelatedAngles.length) {

      this.relatedAngleTitles = JSON.parse(JSON.stringify(this.postRelatedAngles));
      this.relatedAngleTitles = this.relatedAngleTitles.map((angle) => {

        return {
          angleId: angle.angleId,
          angleTitle: angle.angleTitle,
          angleIdTitle: '(' + angle.angleId + ') ' + angle.angleTitle
        };

      });

    }

  }

  resetOptions() {

    this.filteredOptions = [];
    this.filteredOptionsInit = [];
    this.listofStories = [];

    this.filteredAngleOptions = [];
    this.filteredAngleOptionsInit = [];
    this.listofAngles = [];

  }

  bindTitleDetails() {

    const updatedRelatedStories = [];

    this.relatedStoryTitles.forEach(story => {

      const temp = this.listofStories.filter(a => a.storyId === story.storyId)[0];

      if (temp === null || temp === undefined) {

        return;

      }
      updatedRelatedStories.push({
        storyId: story.storyId,
        storyTitle: (temp && temp.storyTitle) ? temp.storyTitle : '',
        isPrimary: story.isPrimary,
        isPinnedOnTop: this.isPinnedOnTop
      });

    });
    this.relatedStoryTitles = [...updatedRelatedStories];

    // console.log('ngOnChanges Related Stories1', updatedRelatedStories, this.listofStories);

  }

  getAngleTitles(queryStr?) {

    let params;

    if (queryStr) {

      params = `?searchText=${queryStr}`;

    } else {

      this.filteredAngleOptions = [];
      return;

    }
    this.cService.serviceRequestCommon('get', environment.getAngleTitle, params).subscribe(
      (data: any) => {

        const angles = data.map((angle) => {

          return {
            angleId: angle.angleId,
            angleTitle: angle.angleTitle,
            angleIdTitle: '(' + angle.angleId + ') ' + angle.angleTitle
          };

        });

        const angleMatchingTitles: Angle[] = JSON.parse(JSON.stringify(angles));

        this.listofAngles = angleMatchingTitles.filter(angle =>
          this.relatedAngleTitles.every(assignedAngle => angle.angleId !== assignedAngle.angleId));

        this.filteredAngleOptions = this.listofAngles.map((angle) => angle.angleIdTitle);
        this.filteredAngleOptionsInit = this.listofAngles.map((angle) => angle.angleIdTitle);

      },
      (error: any) => {

        console.log(error);

      }
    );

  }

  getStoryTitlesList(queryStr?: string) {

    let params: string;

    if (queryStr) {

      //params = `?storyTitle=${queryStr}`;
      params = `?searchString=${queryStr}&contentType=Story&startIndex=1&endIndex=50&sortField=modificationDate&sortOrder=descending`;

    } else {

      this.filteredOptions = [];
      return;

    }
    this.cService.serviceRequestCommon('post', this.getStoryTitlesAPI, params).subscribe((data: any) => {

      const tempStoiesObj = data.storySearchResult.map((story: any) => {

        return {
          storyId: story.storyID,
          storyTitle: story.storyTitle,
          isPrimary: false,
          isPinnedOnTop: this.isPinnedOnTop,
          topics: story.topics
        };

      });

      this.listofStories = JSON.parse(JSON.stringify(tempStoiesObj));
      this.filteredOptions = this.listofStories.map((story) => story.storyTitle); //
      this.filteredOptionsInit = this.listofStories.map((story) => story.storyTitle);

    });

  }

  angleMatch(angleValue) {

    const obj = this.listofAngles.filter(angle => angle.angleIdTitle === angleValue)[0];

    if (!(obj === null || obj === undefined)) {

      this.relatedAngleTitles.push(obj);
      this.mapAdditionalAnglesToPost();
      setTimeout(() => {

        this.angleValue = '';

      }, 100);

    }
    if (this.filteredAngleOptionsInit && this.filteredAngleOptionsInit.length) {

      this.filteredAngleOptions = [...this.filteredAngleOptionsInit];

    }

  }

  titleMatch(value) {

    const obj = this.listofStories.filter(story => story.storyTitle === value)[0];

    const obj1 = this.relatedStoryTitles.filter(story => story.storyTitle === value)[0];

    if ((!(obj === null || obj === undefined) && (obj1 === null || obj1 === undefined))) {

      if (!(this.relatedStoryTitles && this.relatedStoryTitles.length)) {

        obj.isPrimary = true;

      }
      obj.isPinnedOnTop = this.isPinnedOnTop;
      this.relatedStoryTitles.push(obj);
      this.mapAdditionalStoryToPost();
      setTimeout(() => {

        this.value = '';

      }, 100);

    }
    if (this.filteredOptionsInit && this.filteredOptionsInit.length) {

      this.filteredOptions = [...this.filteredOptionsInit];

    }

  }

  onInput(value: string): void {

    this.options = value ? [value] : [];

  }

  saveSettings() {

    // console.log('CLICK DEBOUNCE TEST : ' );
  }

  onChange(value: string, event: any): void {

    setTimeout(() => {

      this.subject.next(event.target.value);

    }, 200);

  }

  searchAngle(value: string, event: any): void {

    setTimeout(() => {

      this.angleSubject.next(event.target.value);

    }, 200);

  }

  onEnter(_value) {

    // console.log('Entered value', value, this.relatedStoryTitles);
    // const obj = this.listofStories.filter(story => story.storyTitle === value)[0];
    // const obj1 = this.relatedStoryTitles.filter(story => story.storyTitle === value)[0];
    // if ((!(obj === null  || obj === undefined) && (obj1 === null  || obj1 === undefined))) {
    //   if (!(this.relatedStoryTitles && this.relatedStoryTitles.length)) {
    //     obj.isPrimary = true;
    //   }
    //   this.relatedStoryTitles.push(obj);
    //   this.mapAdditionalStoryToPost();
    // }
    // this.value = '';
    // this.filteredOptions = [...this.filteredOptionsInit];

  }

  assignValues(val) {

    if (!val) {

      this.filteredOptions = this.filteredOptionsInit;

    }
    this.filteredOptions = this.filteredOptionsInit.filter((item) => {

      if (item !== null && item !== undefined) {

        const storyTitle = item.toLowerCase();

        // console.log('storyTitle ', value, event);
        if (storyTitle.includes(val.toLowerCase())) {

          return item;

        }

      }

    });

  }

  mapAdditionalAnglesToPost() {

    const relatedAngles = this.relatedAngleTitles.filter(({ angleId, angleTitle }, index, a) =>
      a.findIndex(e => angleId === e.angleId &&
        angleTitle === e.angleTitle) === index);

    this.addedAngles.emit({ postRelatedAngles: relatedAngles });
    this.resetOptions();

  }

  mapAdditionalStoryToPost() {

    // this.relatedStoryTitles = this.relatedStoryTitles.map((story) => {
    //   return {
    //    storyId: story.storyId,
    //    isPrimary: story.isPrimary,
    //    isPinnedOnTop: story.isPinnedOnTop,
    //   };
    //  });
    this.addedStories.emit({ relatedStories: this.relatedStoryTitles, isPinnedOnTop: this.isPinnedOnTop });
    this.resetOptions();

  }

  pinStory(storyId, value) {

    this.isPinnedOnTop = !value;
    this.relatedStoryTitles = this.relatedStoryTitles.map(element => {

      element.isPinnedOnTop = !value;

      // if (element.storyId === storyId) {
      //   element.isPinnedOnTop = (element.isPinnedOnTop) ? false : true;
      // }
      return element;

    });
    this.mapAdditionalStoryToPost();

  }

  postAsPrimaryStory(storyId) {

    this.relatedStoryTitles.map((element) => {

      if (element.storyId === storyId) {

        element.isPrimary = true;

        //(document.getElementsByClassName('primaryStory')[index] as HTMLElement).style.backgroundColor = '#1890FF';

      } else {

        element.isPrimary = false;

        //(document.getElementsByClassName('primaryStory')[index] as HTMLElement).style.backgroundColor = '#fff';

      }

    });
    this.mapAdditionalStoryToPost();

  }

  deleteRelatedStories(index, storyId) {

    this.relatedStoryTitles.forEach((element, itemindex) => {

      if (storyId === element.storyId) {

        this.relatedStoryTitles.splice(itemindex, 1);

      }

    });
    if (index.isPrimary) {

      if (this.relatedStoryTitles && this.relatedStoryTitles.length) {

        this.relatedStoryTitles[0].isPrimary = true;

      }

    }
    this.addedStories.emit({ relatedStories: this.relatedStoryTitles, isPinnedOnTop: this.isPinnedOnTop });
    this.resetOptions();

  }

  deleteRelatedAngles(index, angleId) {

    this.relatedAngleTitles.forEach((element, itemindex) => {

      if (angleId === element.angleId) {

        this.relatedAngleTitles.splice(itemindex, 1);

      }

    });
    this.addedAngles.emit({ postRelatedAngles: this.relatedAngleTitles });
    this.resetOptions();

  }

}
